import { render, staticRenderFns } from "./OrderCandidates.vue?vue&type=template&id=1062de1d"
import script from "./OrderCandidates.vue?vue&type=script&lang=js"
export * from "./OrderCandidates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports